<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="page_vi"></a> <em>Remembering the Bones</em><br/>© 2007 by Itani Writes Inc. All rights reserved.</p>
<p class="copyright">A Phyllis Bruce Book, published by HarperCollins Publishers Ltd.</p>
<p class="copyright">No part of this book may be used or reproduced in any manner<br/>whatsoever without the prior written permission of the publisher,<br/>except in the case of brief quotations embodied in reviews.</p>
<p class="copyright">HarperCollins books may be purchased for educational, business,<br/>or sales promotional use through our Special Markets Department.</p>
<p class="copyright">HarperCollins Publishers Ltd<br/>2 Bloor Street East, 20th Floor<br/>Toronto, Ontario, Canada<br/><span class="small">M4W IA</span>8</p>
<p class="copyright"><em>www.harpercollins.ca</em></p>
<p class="copyright">Library and Archives Canada Cataloguing in Publication</p>
<p class="copyright">Itani, Frances, 1942–<br/>Remembering the bones: a novel / Frances Itani.</p>
<p class="copyright">eBook ISBN-13: 978-1-5558-4812-5</p>
<p class="copyright">I. Title.</p>
<p class="copyright"><span class="small">PS</span>8567.<span class="small">T</span>35<span class="small">R</span>39 2007 <span class="small">C</span>813’.54 <span class="small">C</span>2007-902800-4</p>
<p class="copyright"><span class="small">HC</span> 9 8 7 6 5 4 3 2 1</p>
<p class="copyright">Printed and bound in the United States<br/>Designed by Sharon Kish</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?61d17f4a